import EventBus from '@/utils/event-bus'

export async function executeWithSpinner (func, types={}) {
  const {loading, success, fail} = types
  EventBus.$emit('spinner-msg', {type: loading || 'loading'})
  try {
    await func()
    EventBus.$emit('spinner-msg', {off: true})
    EventBus.$emit('spinner-msg', {type: success || 'success'})
  } catch (error) {
    EventBus.$emit('spinner-msg', {type: fail || 'fail'})
    throw error
  }
}
